import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const services = [
  { title: "Trekking", icon: "bi-person-walking" },
  { title: "The Map", icon: "bi-map" },
  { title: "Suitcase", icon: "bi-suitcase-lg" },
  { title: "Island Tour", icon: "bi-sun" }
];

export default function Services() {
  return (
    <section className="py-5 bg-light" id="services">
      <div className="container">
        <div className="mb-5">
          <h6 className="text-uppercase fw-bold" style={{ color: '#1cc3b2', letterSpacing: '2px' }}>Our Services</h6>
        </div>
        
        <Swiper
          modules={[Pagination]}
          spaceBetween={30}
          slidesPerView={1}
          pagination={{ clickable: true }}
          breakpoints={{
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
          }}
          className="pb-5"
        >
          {services.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="card border-0 shadow-sm p-5 text-center h-100">
                <div className="mb-4">
                  <i className={`${item.icon} display-4`} style={{ color: '#1cc3b2' }}></i>
                </div>
                <h4 className="fw-bold mb-3">{item.title}</h4>
                <p className="text-muted">
                  Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.
                </p>
                <a href="#" className="text-decoration-none fw-bold mt-3 d-inline-block" style={{ color: '#1cc3b2', fontSize: '12px', letterSpacing: '1px' }}>
                  LEARN MORE
                </a>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}